import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const checkboxThemeInput = {
    palette: {
        primary: {
            main: colors.accent.foreground.success,
            dark: colors.accent.foreground.success,
        },
    },
    components: {
        MuiCheckbox: {
            styleOverrides: {
                colorPrimary: {
                    color: colors.secondary,
                },
                root: {
                    zIndex: 0,
                    '&.Mui-disabled': {
                        color: colors.secondaryDisabled,
                    },
                    '& .MuiTouchRipple-root': {
                        zIndex: -1,
                    },
                    '& .MuiTouchRipple-rippleVisible': {
                        color: colors.hoverFocus,
                    },
                    ':hover': {
                        backgroundColor: colors.selectedBackground,
                    },
                },
            },
        },
    },
};
var checkboxTheme = createTheme(shippoTheme, checkboxThemeInput);

export { checkboxThemeInput, checkboxTheme as default };
//# sourceMappingURL=Checkbox.theme.js.map
